export const CSRF_KEY = 'csrf-token';
